module.exports = __webpack_public_path__ + "static/media/stage.12cb215d.glb";